// Chart colours come from the CSS variables in resources/css/theme.css
// (see docs/design-tokens.md), so charts follow the same tokens as the rest
// of the dashboard. Values are read when a chart is drawn, not at import.

const FALLBACK = '36 38 71';

const cssVar = (name) => {
    const value = getComputedStyle(document.documentElement).getPropertyValue(`--${name}`).trim();
    return value || FALLBACK;
};

/** `rgba(r, g, b, a)` for a space-separated RGB CSS variable such as --chart-1. */
export const tokenColor = (name, alpha = 1) => {
    const [r, g, b] = cssVar(name).split(/\s+/);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const chartTheme = {
    /** Categorical series colour, 1-based: chartTheme.series(1) … series(8). */
    series: (i, alpha = 1) => tokenColor(`chart-${i}`, alpha),
    /** Sequential ramp for stacked series, strongest first (1…5). */
    sequential: (i, alpha = 1) => tokenColor(`chart-seq-${i}`, alpha),
    get grid() { return tokenColor('chart-grid'); },
    get axis() { return tokenColor('chart-axis'); },
    get positive() { return tokenColor('chart-positive'); },
    get negative() { return tokenColor('chart-negative'); },
    get tiktok() { return tokenColor('chart-tiktok'); },
    get spotify() { return tokenColor('chart-spotify'); },
    get brand() { return tokenColor('color-brand'); },
    get brandSoft() { return tokenColor('color-brand-200'); },
    get accent() { return tokenColor('color-accent'); },
    get accentStrong() { return tokenColor('chart-2'); },
    get text() { return tokenColor('color-text-primary'); },
    get muted() { return tokenColor('color-text-muted'); },
    get surface() { return tokenColor('color-surface'); },
    get border() { return tokenColor('color-border-subtle'); },
    /** Dark tooltip panel, matching x-tooltip. */
    get tooltipBackground() { return tokenColor('color-brand-990'); },
    onDark: {
        get axis() { return tokenColor('chart-on-dark-axis'); },
        get grid() { return tokenColor('chart-on-dark-grid', 0.08); },
        get guide() { return tokenColor('chart-on-dark-grid', 0.55); },
    },
};
